module.exports = __webpack_public_path__ + "img/n1-8.5010e9d5.png";